import { YStack } from '@/components/ui/layout/layout';
import { SettingsSection } from '@/features/settings/settings-section';

import { teamApis } from '../team.query';

type TeamTranscriptStorageCardProps = {
  teamId: string;
  storeTranscripts: boolean;
};

export const TeamTranscriptStorageCard = ({
  teamId,
  storeTranscripts,
}: TeamTranscriptStorageCardProps) => {
  return (
    <YStack className="w-full gap-3">
      <SettingsSection.GroupHeader>
        Meeting Transcripts
      </SettingsSection.GroupHeader>
      <SettingsSection.Group>
        <SettingsSection.Item direction="horizontal">
          <SettingsSection.ItemHeader>
            <SettingsSection.ItemLabel>
              Keep meeting transcripts
            </SettingsSection.ItemLabel>
            <SettingsSection.ItemDescription>
              When off, transcripts are deleted as soon as the meeting summary
              is written. Summaries and notes are kept. Transcripts already
              stored are not deleted.
            </SettingsSection.ItemDescription>
          </SettingsSection.ItemHeader>
          <SettingsSection.Switch
            checked={storeTranscripts}
            onCheckedChange={(checked) =>
              teamApis.updateDataControls(teamId, {
                store_meeting_transcripts: checked,
              })
            }
          />
        </SettingsSection.Item>
      </SettingsSection.Group>
    </YStack>
  );
};
